import React from "react";
import "./header.css";
import "./headerResponsiveStyleSheet.css"
import {DefaultParameters, HubspotInfo} from "../../api/ApiCallMethod";
import Button from "../Buttons/Button";
import Icon from "../../Assets/IconLibrary/Icon";
import HubspotForm from "react-hubspot-form";
import PianoLoading from "../../Assets/Loading/PianoLoading";
import Popup from "reactjs-popup";

import Logo from "../../Assets/Images/Illustrations/Logo.svg"
import { slide as Menu} from 'react-burger-menu'

export default class Header extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            menuList: [
                {
                    Name: "Solutions",
                    Availability: true,
                    OnHover: () => this.props.onHover("solutions"),
                    Action: this.changeRouteHandler.bind(this, "solutions")
                },
                {
                    Name: "Pricing",
                    Availability: true,
                    OnHover: () => this.props.onHover("pricing"),
                    Action: this.changeRouteHandler.bind(this, "pricing")
                },
                {
                    Name: "Company",
                    Availability: true,
                    OnHover: () => this.props.onHover("company"),
                    Action: this.changeRouteHandler.bind(this, "company")
                },
            ],
            openBurgerMenu: false,
            launchingSoonPopup: false,
            activeMenu: "",
            productVideoPopup: false,
            contactUsPopup: false,
            designRoutes: [
                "solutions",
                "pricing",
                "company",
                "home",
                "",
            ]
        }
    }


    login = () => {
        let productUrl = DefaultParameters().ProductURL
        productUrl += DefaultParameters().LoginRoute
        window.open(productUrl, '_blank');

    }


    requestDemo = () => {
        this.setState({
            contactUsPopup: true
        })
    }

    closeContactUsForm = () => {
        this.setState({
            contactUsPopup: false,
        })
    };

    submitForm = () => {
        this.setState({
            contactUsPopup: false,
        })
    }

    changeRouteHandler = (route) => {

        let {menuList} = this.state;
        for (let i = 0; i < menuList.length; i++) {
            menuList[i].isActive = menuList[i].Route === route
        }
        let {routingPage} = this.props;
        routingPage(route);

        this.setState({
            activeMenu: "",
            openBurgerMenu: false,
        })


    }

    changeRoute = (menuName, action) => {
        this.setState({
            activeMenu: menuName,
            openBurgerMenu: false,
        })
        action();
    }


    render() {
        let currentURL = window.location.href;
        let urlArray = currentURL.split("/");
        let lastURL = urlArray[urlArray.length - 1];
        let {menuList} = this.state;
        let {scrollTop} = this.props;
        return (

            <div className={scrollTop <= 30 ? "main-header-division" : "main-header-division floating-menu-bar"}>
                <div className="main-header--left">
                    <img src={Logo}
                         alt="AnyGen Logo"
                         className={this.state.designRoutes.includes(lastURL) ? "main-header-logo" : "main-header-logo center-align"}
                         onClick={this.changeRouteHandler.bind(this, "")}/>
                </div>
                <div className="main-header--center">
                    <div className="main-menu-list">

                        {
                            menuList.map((menu, mid) =>
                                <button
                                    className={lastURL === menu.Name.toLowerCase() ? "main-menu-button active" : "main-menu-button"}
                                    id={mid}
                                    key={mid}
                                    onMouseOver={menu.OnHover}
                                    onClick={this.changeRoute.bind(this, menu.Name, menu.Action)}
                                    disabled={!menu.Availability}>
                                    <div className="main-menu-background-container">
                                        <div className="main-menu-background-container-light"/>
                                    </div>
                                    {menu.Name}
                                    {lastURL === menu.Name ? "active" : ""}

                                </button>
                            )
                        }
                    </div>
                </div>
                <div className="main-header--right">
                    <div className="main-header-right-menu-btn">
                        <Button type={"secondary"} width={"170px"} onClick={this.login.bind(this)}>
                            Login
                        </Button>
                    </div>
                    <div className="main-header-request-demo-btn">
                        <Button width={"170px"} onClick={this.requestDemo.bind(this)}>
                            Request Demo
                        </Button>
                    </div>

                    <div className="main-header-burger-menu-button">
                        <Menu right isOpen={this.state.openBurgerMenu} onOpen={()=>this.setState({openBurgerMenu: true})} onClose={()=>this.setState({openBurgerMenu: false})}>
                            <div className='anyGen-burger-main-menu-list'>
                                <div className="anyGen-burger-logo-container" onClick={this.changeRouteHandler.bind(this,"home")}>
                                    <div className='anyGen-logo-burger-division'>
                                        <img src={Logo} className="anygen-logo"
                                             alt={"AnyGen AI Logo"}
                                             width={"100%"} height={40}/>
                                    </div>
                                    <button className="anygen-logo-close-btn" onClick={()=>this.setState({openBurgerMenu: false})}>
                                        <Icon name="close" colorList={["white"]}/>
                                    </button>
                                </div>


                                <div className="anyGen-logo-burger-menu-list">
                                    {
                                        this.state.menuList.map((menu,index)=>
                                            <button key={menu.Name}
                                                    className={menu.isActive?"anyGen-main-menu active":"anyGen-main-menu" }
                                                    disabled={!menu.Availability}
                                                    value={menu.Route}
                                                    onClick={menu.Action}>
                                                {menu.Name}
                                            </button>
                                        )
                                    }




                                </div>
                                <div className='burger-menu-button-row'>
                                    <Button type="secondary" width={"170px"} height="40px" onClick={this.login.bind(this)}>Login</Button>
                                    <Button type="primary" width={"170px"} height="40px" onClick={this.requestDemo.bind(this)}>Request Demo</Button>
                                </div>

                            </div>
                        </Menu>
                    </div>
                </div>



                <Popup contentStyle={{
                    background: "transparent",
                    padding: 0,
                    border: "none",
                    borderRadius: "none",
                }}
                       open={this.state.contactUsPopup}
                       closeOnDocumentClick={false}
                       lockScroll={true}>
                    <div className="contact-us-popup-container">
                        <div className="contact-us-popup">
                            <div className="contact-us-popup-inner-division">

                                <div className="contact-us-title">
                                    Contact Us
                                </div>
                                <button className="contact-us-close-btn" onClick={this.closeContactUsForm.bind(this)}>
                                    <Icon name="close" colorList={["white"]}/>
                                </button>

                                <div className="contact-us-form-container">
                                    <HubspotForm
                                        portalId={HubspotInfo.HubspotPortalID}
                                        formId={HubspotInfo.RequestDemoFormID}
                                        onSubmit={() => this.submitForm.bind(this)}
                                        onReady={() => this.submitForm.bind(this)}
                                        cssRequired={""}
                                        cssClass={"contact-us-form"}
                                        submitButtonClass={"contact-us-button"}
                                        loading={<PianoLoading/>}
                                    />
                                </div>



                            </div>
                        </div>
                    </div>

                </Popup>
            </div>
        );
    }

}